import { Download, MonitorSmartphone } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@nucleus-commerce/ui/components/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@nucleus-commerce/ui/components/card';

import { useInstallPrompt } from '../hooks/use-install-prompt';
import { promptInstall } from '../lib/install-prompt';
import { isAppleMobile, isStandalone } from '../lib/push-browser';

/** The admin as an installable app (LC16): Chromium's prompt when it offers one, else directions. */
export function InstallAppCard() {
  const { t } = useTranslation('push');
  const canPrompt = useInstallPrompt();
  const [standalone] = useState(isStandalone);
  const [apple] = useState(() => isAppleMobile(navigator.userAgent));

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <MonitorSmartphone className="text-muted-foreground size-4" aria-hidden />
          <CardTitle>{t('install.title')}</CardTitle>
        </div>
        <CardDescription>{t('install.description')}</CardDescription>
      </CardHeader>
      <CardContent className="text-sm">
        {standalone ? (
          <p className="text-muted-foreground">{t('install.installed')}</p>
        ) : canPrompt ? (
          <Button onClick={() => void promptInstall()}>
            <Download aria-hidden />
            {t('install.button')}
          </Button>
        ) : (
          <p className="text-muted-foreground">{apple ? t('install.ios') : t('install.manual')}</p>
        )}
      </CardContent>
    </Card>
  );
}
